module.exports = __webpack_public_path__ + "img/274d3df.jpg";